<template>
  <div class="sidebar sidebar-hidden" :class="{'sidebar-hidden' : navigationPin}">
    <ul class="nav flex-column">
      <li class="nav-item">
        <router-link class="nav-link" to="/">
          <img src="static/logo@2x.png" class="d-md-block utku-logo" width="124" height="32" />
          <img src="static/butterfly_.svg" v-if="getPersonelId == 3 || getPersonelId == 24" class="d-md-block svg-butterfly bg-primary" width="40" height="40" />
          <small class="app-version">2026.09.03.001</small>
        </router-link>
      </li>
      <li class="nav-item" :class="{'active' : activeMenuIndex == 0}">
        <router-link to="/" :class="'nav-link align-middle'">
          <i class="fas fa-home mr-2"></i>
          <span>Ana Ekran</span>
        </router-link>
      </li>
      <li v-if="canViewStok || canViewSerials" class="nav-item has-child" :class="{'active' : activeMenuIndex == 1}">
        <a class="nav-link align-middle" @click="openSub(0)">
          <i class="fas fa-archive mr-2"></i>
          <span>Stok Yönetimi</span>
          <i class="fas fa-caret-down"></i>
        </a>
        <ul class="child-list" v-if="subStatesFirst">
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/stok">
              <i class="fas fa-angle-right"></i>
              <span>Malzemeler</span>
            </router-link>
          </li>
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/stok/seri-numaralar">
              <i class="fas fa-angle-right"></i>
              <span>Seri Numarlar</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li v-if="canViewProducts" class="nav-item has-child" :class="{'active' : activeMenuIndex == 2}">
        <a class="nav-link align-middle" @click="openSub(1)">
          <i class="fas fa-cogs mr-2"></i>
          <span>Üretim</span>
          <i class="fas fa-caret-down"></i>
        </a>
        <ul class="child-list" v-if="subStatesSecond">
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/uretim/urunler">
              <i class="fas fa-angle-right"></i>
              <span>Ürünler</span>
            </router-link>
          </li>
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/uretim/setler">
              <i class="fas fa-angle-right"></i>
              <span>Ürün Setleri</span>
            </router-link>
          </li>
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/uretimler">
              <i class="fas fa-angle-right"></i>
              <span>Üretim Ekranı</span>
            </router-link>
          </li>
        </ul>
      </li>
      <li v-if="canViewAriza" class="nav-item" :class="{'active' : activeMenuIndex == 3}">
        <router-link class="nav-link align-middle" to="/ariza-kayitlari">
          <i class="fas fa-heart-broken mr-2"></i>
          <span class="">Arıza Takip</span>
        </router-link>
      </li>
      <!--<li v-if="canViewSahaOperasyon" class="nav-item" :class="{'active' : activeMenuIndex == 4}">
        <router-link class="nav-link align-middle" to="/saha-operasyon">
          <i class="fas fa-map mr-2"></i>
          <span>Saha - Operasyon</span>
        </router-link>
      </li>-->
      <li v-if="canViewUrunCikis" class="nav-item" :class="{'active' : activeMenuIndex == 12}">
        <router-link class="nav-link align-middle" to="/teklifler">
          <i class="far fa-file mr-2"></i>
          <span class="">Teklif Talepleri</span>
        </router-link>
      </li>
      <li v-if="canViewUrunCikis" class="nav-item" :class="{'active' : activeMenuIndex == 28}">
        <router-link class="nav-link align-middle" to="/demo-talepleri">
          <i class="far fa-file mr-2"></i>
          <span class="">Demo Talepleri</span>
        </router-link>
      </li>
      <li v-if="canViewUrunCikis" class="nav-item" :class="{'active' : activeMenuIndex == 13}">
        <router-link class="nav-link align-middle" to="/aranma-talepleri">
          <i class="fas fa-phone mr-2"></i>
          <span class="">Aranma Talepleri</span>
        </router-link>
      </li>
      <li v-if="canViewUrunCikis" class="nav-item" :class="{'active' : activeMenuIndex == 5}">
        <router-link class="nav-link align-middle" to="/urun-cikislari">
          <i class="fas fa-money-check-alt mr-2"></i>
          <span>Yeni Ürün Çıkışları</span>
        </router-link>
      </li>
      <li v-if="canViewSahaOperasyon" class="nav-item has-child" :class="{'active' : activeMenuIndex == 4}">
        <a class="nav-link align-middle" @click="openSub(2)">
          <i class="fas fa-map mr-2"></i>
          <span>Saha - Operasyon</span>
          <i class="fas fa-caret-down"></i>
        </a>
        <ul class="child-list" v-if="subStatesThird">
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/saha-operasyon">
              <i class="fas fa-angle-right"></i>
              <span>Operasyon Kayıtları</span>
            </router-link>
          </li>
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/montaj-noktalari">
              <i class="fas fa-angle-right"></i>
              <span>Montaj Noktaları</span>
            </router-link>
          </li>
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/servis-randevulari">
              <i class="fas fa-angle-right"></i>
              <span>Servis Randevuları</span>
            </router-link>
          </li>
        </ul>
      </li>
      <!--
      <li v-if="canViewUrunCikis" class="nav-item" :class="{'active' : activeMenuIndex == 6}">
        <router-link class="nav-link align-middle" to="/sarf-malzemeleri">
          <i class="fas fa-puzzle-piece mr-2"></i>
          <span>Sarf Malzemeleri</span>
        </router-link>
      </li>
      -->
      <!--
      <li class="nav-item" :class="{'active' : activeMenuIndex == 7}">
        <router-link class="nav-link align-middle" to="/notlar">
          <i class="far fa-clipboard mr-2"></i>
          <span>Notlar</span>
        </router-link>
      </li>
      -->
      <!--
      <li class="nav-item" :class="{'active' : activeMenuIndex == 8}">
        <router-link class="nav-link align-middle" to="/debug">
          <i class="fas fa-spider mr-2"></i>
          <span>Test Ekranı</span>
        </router-link>
      </li>
      -->
      <li v-if="canViewUrunCikis" class="nav-item has-child" :class="{'active' : activeMenuIndex == 9}">
        <a class="nav-link align-middle" @click="openSub(3)">
          <i class="fas fa-sim-card mr-2"></i>
          <span>Hatlar</span>
          <i class="fas fa-caret-down"></i>
        </a>
        <ul class="child-list" v-if="subStatesFourth">
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/hatlar">
              <i class="fas fa-angle-right"></i>
              <span>Hatlar</span>
            </router-link>
          </li>
          <li class="child-nav">
            <router-link class="nav-link align-middle" to="/hatlar/iccid-pairs">
              <i class="fas fa-angle-right"></i>
              <span>ICCID Eşleşmeleri</span>
            </router-link>
          </li>
        </ul>
      </li>
      <!--
      <li v-if="canView" class="nav-item" :class="{'active' : activeMenuIndex == 10}">
        <router-link class="nav-link align-middle" to="/bayii-aidat-takibi">
          <i class="far fa-calendar-minus mr-2"></i>
          <span>Bayii Aidat Takibi</span>
        </router-link>
      </li>
      -->
      <li v-if="canViewUetds"  class="nav-item" :class="{'active' : activeMenuIndex == 21}">
        <router-link class="nav-link align-middle" to="/uetds/araclar">
          <i class="fa fa-plug mr-2"></i>
          <span>U-ETDS</span>
        </router-link>
      </li>
      <li v-if="canViewCargoTracking"  class="nav-item" :class="{'active' : activeMenuIndex == 22}">
        <router-link class="nav-link align-middle" to="/kargo-takip">
          <i class="fa fa-truck mr-2"></i>
          <span>Kargo Kayıtları</span>
        </router-link>
      </li>
      <li v-if="canViewCargoTracking"  class="nav-item" :class="{'active' : activeMenuIndex == 23}">
        <router-link class="nav-link align-middle" to="/fiyat-listesi">
          <i class="fas fa-money-bill-wave mr-2"></i>
          <span>Fiyat Listesi</span>
        </router-link>
      </li>
      <li v-if="canViewCargoTracking"  class="nav-item" :class="{'active' : activeMenuIndex == 24}">
        <router-link class="nav-link align-middle" to="/luca-kodlari">
          <i class="fas fa-code mr-2"></i>
          <span>Luca Kodları</span>
        </router-link>
      </li>
      <li v-if="canViewCargoTracking"  class="nav-item" :class="{'active' : activeMenuIndex == 25}">
        <router-link class="nav-link align-middle" to="/fatura-yuklemeleri">
          <i class="fas fa-file-invoice mr-2"></i>
          <span>Fatura Yüklemeleri</span>
        </router-link>
      </li>
      <li v-if="canViewCargoTracking"  class="nav-item" :class="{'active' : activeMenuIndex == 26}">
        <router-link class="nav-link align-middle" to="/fatura-yildizlari">
          <i class="fas fa-star mr-2"></i>
          <span>Fatura Yıldızları</span>
        </router-link>
      </li>
      <li v-if="canViewCargoTracking"  class="nav-item" :class="{'active' : activeMenuIndex == 27}">
        <router-link class="nav-link align-middle" to="/kesik-cihazlar">
          <i class="fas fa-wifi mr-2"></i>
          <span>Çevrimdışı Cihazlar</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
/* eslint-disable */

import axios from 'axios'

export default {
  name: 'LeftBar',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      notifyMode: 0, // -1: old but not shown, 0 : all of today, 1: each today, 2: incoming
      showNavbar: false,
      notifications:[],
      notes: [],
      notifyPermissionGranted: false,
      notesNotifierProcessId: 0,
      notifyNoteIndex: 0,
      notificationOptions: {
        title: '',
        body: '',
        icon: '/static/logo@2x.png'
      },
      queryModel: {
        SessionId: '',
        NoteType: -1,
        SearchFilter: ''
      },
      subStates: [false, false],
      subStatesFirst : false,
      subStatesSecond : false,
      subStatesThird: false,
      subStatesFourth: false,
    }
  },
  props:{
    activeMenuIndex : Number
  },
  computed: {
    getPersonelName : function() { return this.$store.state.user.personelName },
    getPersonelId : function() { return this.$store.state.user.personelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
    /* --- */
    canAddAriza : function() { return this.$store.getters.userCanAddAriza },
    canUpdateAriza : function() { return this.$store.getters.userCanUpdateAriza },
    canViewAriza : function() { return this.$store.getters.userCanViewAriza },
    canDeleteAriza : function() { return this.$store.getters.userCanDeleteAriza },
    canAssignTrackingNumber : function() { return this.$store.getters.userCanAssignTrackingNumber },
    /* --- */
    canAddStok : function() { return this.$store.getters.userCanAddStok },
    canSpendStok : function() { return this.$store.getters.userCanSpendStok },
    canViewStok : function() { return this.$store.getters.userCanViewStok },
    canDeleteStok : function() { return this.$store.getters.userCanDeleteStok },
    /* --- */
    canViewProducts : function() { return this.$store.getters.userCanViewProducts},
    canCreateProduct : function() { return this.$store.getters.userCanCreateProduct},
    canDeleteProduct : function() { return this.$store.getters.userCanDeleteProduct},
    canCalculateProduction : function() { return this.$store.getters.userCanCalculateProduction},
    /* --- */
    canViewUrunCikis : function() { return this.$store.getters.userCanViewUrunCikis},
    canInsertUrunCikis : function() { return this.$store.getters.userCanInsertUrunCikis},
    canDeleteUrunCikis : function() { return this.$store.getters.userCanDeleteUrunCikis},
    /* --- */
    canViewSahaOperasyon : function() { return this.$store.getters.userCanViewSahaOperasyon },
    /* --- */
    canViewSerials : function() { return this.$store.getters.userCanViewSerials },
    canAddSerials : function() { return this.$store.getters.userCanAddSerials },
    canUseNotes : function() { return this.$store.getters.userCanUseNotes; },
    canViewSIMCards : function() { return this.$store.getters.userCanViewSIMCards; },
    /* --- */
    canViewUetds: function() { return this.$store.getters.userCanViewUetds },
    /* --- */
    canViewCargoTracking: function() { 
      return this.getPersonelId == 3 || 
        this.getPersonelId == 24 || 
        this.getPersonelId == 58 ||
        this.getPersonelId == 64 ||
        this.getPersonelId == 71 ||
        this.getPersonelId == 83
    },
    /* --- */
    notificationCount: function() { return this.notifications.filter(m => m.NTF_SEEN == "False").length },
    /* --- */
    navigationPin : function() { return this.$store.getters.pinNavigationDrawer }
  },
  methods: {
    async getNotes() {
      this.queryModel.SessionId = this.getSessionId
      this.queryModel.NoteType = -1
      this.queryModel.SearchFilter = ""
      axios.post('/api/session/notes', this.queryModel)
      .then(response => {
        let cacheNotes = response.data
        let date = new Date()
        let dayOfWeek = date.getDay() + 1 // Week start number is 1. not 0
        for(let i = 0; i < cacheNotes.length; i++) {
          let noteObj = cacheNotes[i]
          let addNum = noteObj.NOTE_DAYINWEEK - dayOfWeek
          if(noteObj.NOTE_REMINDER_TYPE == 1)
            addNum = addNum < 0 ? addNum + 7 : addNum
          else if(noteObj.NOTE_REMINDER_TYPE == 2)
            addNum = addNum < 0 ? addNum + 30 : addNum

          if(noteObj.NOTE_REMINDER_TYPE == 1 || noteObj.NOTE_REMINDER_TYPE == 2) {
            noteObj.NOTE_DATEDIFF = addNum
            cacheNotes[i] = noteObj
          }
        }
        
        this.notes = cacheNotes
        cacheNotes = null
      })
      .catch(error => { 
        console.error(error) 
      })
    },
    async getNotifications() {
      if(this.getSessionId == null || this.getSessionId == undefined)
        return;

      await axios.post('/api/session/notifications?SessionId=' + this.getSessionId)
      .then(response => this.notifications = response.data)
      .catch(error => {
        console.log('network hatası')
        console.log(error.state)
        console.log(error.message)
      })

      setTimeout(() => { this.getNotifications() }, 60000)
    },
    async getNotesToRemind() {
      let msgBody = ''
      let msgTitle = ''
      let mq = null
      let counterPrice = 0

      if(this.notifyMode == 0 || this.notifyMode == 1)
        mq = this.notes.filter(m => m.NOTE_DATEDIFF == 0 && m.NOTE_STATUS == true)
      else if(this.notifyMode == 2)
        mq = this.notes.filter(m => (m.NOTE_DATEDIFF > 0 && m.NOTE_DATEDIFF < 4) && m.NOTE_STATUS == true)
      else if(this.notifyMode == -1)
        mq = this.notes.filter(m => m.NOTE_DATEDIFF < 0 && m.NOTE_DATEDIFF > -6 && m.NOTE_STATUS == true)
      
      if(mq == null || mq.length == 0) {
        if(this.notifyMode == 2) this.notifyMode == -1
        else this.notifyMode++

        await this.getNotes()
        this.resetReminder()
        return
      }

      if(this.notifyMode == 0) {
        counterPrice = 0
        for(var i = 0; i < mq.length; i++)
          counterPrice += parseInt(mq[i].NOTE_PRICE.trim())

        msgTitle = 'Utku\'dan Notlar'
        msgBody = 'Bugün ' + mq.length + ' farklı kayıt için toplam ' + counterPrice + ' TL ödemeniz var.'

      } else if(this.notifyMode == 1) {
        let ntf_note = mq[this.notifyNoteIndex]
        if(ntf_note != null) {
          msgTitle = ntf_note.NOTE_CAPTION
          if(ntf_note.NOTE_DESCRIPTION != null && ntf_note.NOTE_DESCRIPTION.length > 0) {
            msgBody = ntf_note.NOTE_DESCRIPTION.length > 75 ? ntf_note.NOTE_DESCRIPTION.substring(0, 72) + "..." : ntf.NOTE_DESCRIPTION
          }

          msgBody += '\r\nMiktar ' + parseInt(ntf_note.NOTE_PRICE) + ' TL'
          if(this.notifyNoteIndex == (mq.length -1)) {
            this.notifyNoteIndex == 0
            this.notifyMode = 2
          } else
            this.notifyNoteIndex++
        }

      } else if(this.notifyMode == 2) {
        counterPrice = 0
        for(var i = 0; i < mq.length; i++)
          counterPrice += parseInt(mq[i].NOTE_PRICE.trim())

        msgTitle = 'Utku\'dan Notlar'
        msgBody = 'Önümüzdeki üç gün içinde ' + mq.length + ' farklı kayıt için toplam ' + counterPrice + ' TL ödemeniz var.'
        this.notifyMode = -1

      } else if(this.notifyMode == -1) {
        counterPrice = 0
        for(var i = 0; i < mq.length; i++)
          counterPrice += parseInt(mq[i].NOTE_PRICE.trim())

        msgTitle = 'Utku\'dan Notlar'
        msgBody = 'Geçtiğimiz beş gün içinde tamamlamadığınız ' + mq.length + ' notunuz var.'

        this.notifyMode = 0
        await this.getNotes()
      }

      this.showNotifications(msgTitle, msgBody)
    },
    showNotifications(msgTitle, msgBody) {
      let timeoutVal = 0
      if(this.notifyMode == 0 || this.notifyMode == -1 || this.notifyMode == 2)
        timeoutVal = 60 * 60 * 1000
      else timeoutVal = 20 * 60 * 1000

      clearTimeout(this.notesNotifierProcessId)
      this.notesNotifierProcessId = setTimeout(() => this.getNotesToRemind(), timeoutVal);

      this.notificationOptions.title = msgTitle
      this.notificationOptions.body = msgBody
      var latif = new Notification(msgTitle, this.notificationOptions)
    },
    prepareReminder() {
      if(('Notification' in window) == false){
        console.log('tarayıcınız bildirim alma özelliğini desteklemiyor.')
        return
      }

      if(Notification.permission !== "denied") {
        Notification.requestPermission().then((perm) => {
          if(perm === "granted")
            this.notifyPermissionGranted = true
        })
        return;
      }

      if(Notification.permission === "granted")
        this.notifyPermissionGranted = true
    },
    resetReminder() {
      clearTimeout(this.notesNotifierProcessId)
      this.notesNotifierProcessId = setTimeout(() => this.getNotesToRemind(), 2 * 60 * 1000)
    },
    parseNotificationType(type) {
      if(type == 0)
        return "Ürün çıkışı yapıldı"
     if(type == 3)
        return "Arıza kaydı oluşturuldu"
     if(type == 1)
        return "Yeni mesaj"
    },
    parseContextLink(notif) {
      let pageContext = null
      if(notif.NTF_CONTEXT_TYPE == 0)
        pageContext = "/urun-cikislari/contexts/"
      else if(notif.NTF_CONTEXT_TYPE = 1)
        pageContext = "/ariza-kayitlari/contexts/"
      else if(notif.NTF_CONTEXT_TYPE == 3)
        pageContext = "/ariza-kayitlari/contexts/"

      return pageContext + notif.NTF_CONTEXT_ID
    },
    registerServiceWorker() {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('static/sw.js')
        .then(function() {
            var reg = navigator.serviceWorker.ready
            reg.active.postMessage('test');
        }).then(function(reg) {
            console.log('Service Worker is ready', reg);
            reg.pushManager.subscribe({userVisibleOnly: true}).then(function(sub) {

                console.log('endpoint:', sub.endpoint);
                reg.active.postMessage(JSON.stringify({uid: uid, token: token}));
                console.log("Posted message");

            });
        }).catch(function(error) {
            console.log('Error : ', error);
        });
      }
    },
    openSub(index) {
      if(index == 0)
        this.subStatesFirst = this.subStatesFirst ? false : true
      else if (index == 1)
        this.subStatesSecond = this.subStatesSecond ? false : true
      else if (index == 2)
        this.subStatesThird = this.subStatesThird ? false : true
      else if (index == 3)
        this.subStatesFourth = this.subStatesFourth ? false : true
    }
  },
  watch: {
    notifyPermissionGranted: function() {
      if(this.notifyPermissionGranted)
        this.notesNotifierProcessId = setTimeout(() => this.getNotesToRemind(), 9000);
      else
        clearTimeout(this.notesNotifierProcessId)
    }
  },
  mounted() {
    //setTimeout(() => this.getNotifications(), 10000)
    //this.prepareReminder()
    //this.getNotes()
    //this.registerServiceWorker()
  }
}
</script>

<style scoped>
  .dropdown-toggle {
    content: '' !important;
  }

  .dropdown-menu-large {
    width: 400px;
  }

  .list-group {
    max-height: 400px !important;
    overflow: auto;
  }

  .list-group-item p {
    font-size: .875rem;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img, .vue-wait-class i {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  i { width: 18px; height: 18px; }
  i.fas, i.fa, i.far{font-family:'Font Awesome\ 5 Free' !important}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  padding: 48px 0 0;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, .1);
  background-color: #010929;
  width: 60px;
  height: calc(100vh);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
  transition: width .15s;
}

.sidebar .nav-item {
  padding: 5px;
  width: 240px;
  background-color: rgba(0,0,0,0);
}

.sidebar .nav-item > a:hover {
  background-color: #41495966;
}

.sidebar .nav-item.active > a {
  background-color: #414959CC;
}

.sidebar .nav-item a {
  padding: 5px 10px 5px 16px;
  border-radius: 3px;
}

.sidebar .nav-item .nav-link > span {
  opacity: 0;
  transition: opacity .15s;
  transition-delay: .15s;
  width: 150px;
  display: inline-block;
  text-align: left;
  user-select: none;
}

.sidebar:hover {
  width: 240px;
  transition: width .15s;
}

.sidebar:hover .nav-item .nav-link > span {
  opacity: 1;
  transition: opacity .15s;
  transition-delay: .15s;
}

.sidebar-sticky {
  position: relative;
  top: 0;
  height: calc(100vh);
  padding-top: .5rem;
  overflow-x: hidden;
  overflow-y: auto; /* Scrollable contents if viewport is shorter than content. */
}

@supports ((position: -webkit-sticky) or (position: sticky)) {
  .sidebar-sticky {
      position: -webkit-sticky;
      position: sticky;
  }
}

.sidebar .nav-item:first-child {
  margin-bottom: 25px;
}

.sidebar .nav-link span, .sidebar .nav-link i {
  color: #FFFFFF;
  text-align: center
}

.sidebar .nav-link img.utku-logo {
  opacity: 0;
  height: auto;
  transition: opacity .15s;
  margin-left: -17px;
}

.sidebar:hover .nav-link img.utku-logo {
  opacity: 1;
  height: auto;
  margin-left: 0;
}

.sidebar .nav-link img.svg-butterfly {
  width: 40px;
  height: 40px;
  padding: 4px;
  position: relative;
  z-index: 2;
  margin-top: -36px;
  margin-left: -10px;
  border-radius: 20px;
  transform: rotateX(20deg);
  transition: margin-left .15s;
}

.sidebar:hover .nav-link img.svg-butterfly {
  margin-left: 150px;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #ffffff;
}

.sidebar-heading {
  font-size: .75rem;
  text-transform: uppercase;
}

.app-version {
  font-size: 14px;
  color: #414959 !important;
}

.nav-item.has-child:hover {
  background-color: #11192900;
}

.nav-item.has-child:hover i.fa-caret-down {
  transform: rotate(180);
}

.child-list {
  display: block;
  width: 100%;
  height: auto;
  list-style-type: none;
  margin: 0;
  margin-top: 5px;
  margin-left: 10px;
  padding: 0;
}

.child-list li {
  margin: 0;
  width: 100%;
}

.child-list li a i {

}

.child-list li a span {

}

</style>



// WEBPACK FOOTER //
// src/components/LeftBar.vue